
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"PDS_Poll\"></div>\r\n<div id=\"PD_superContainer\"></div>\r\n\r\n<div class=\"s-video-landing-slider-item__text\"></div>\r\n<div class=\"s-video-landing-slider-item__container clear\"></div>\r\n");